import { bookingStore } from 'entities/booking/store/store';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react/jsx-runtime';
import { SectionWithActionButton } from 'shared/ui/sectionWithActionButton';
import hospitalIcon from 'assets/hospital_medical.svg';
import clinicIcon from 'assets/iconfinder_geo.svg';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface SelectedBookingOptionsProps {
	showClinics?: boolean;
	showSpecs?: boolean;
}

export const SelectedBookingOptions: FC<SelectedBookingOptionsProps> = observer(
	({ showClinics = false, showSpecs = true }) => {
		const navigate = useNavigate();

		useEffect(() => {
			const clinics = localStorage.getItem('clinics');
			const spec = localStorage.getItem('specialization');
			if (clinics) {
				bookingStore.setClinics(JSON.parse(clinics));
			}

			if (spec) {
				bookingStore.setSpecialization(JSON.parse(spec));
			}
		}, []);

		const redirect = (url: string) => () => {
			navigate(url);
		};

		return (
			<Fragment>
				<div className="mb-2 mt-4">
					{bookingStore.specialization && showSpecs && (
						<SectionWithActionButton
							title="Специализация"
							subtitle={[bookingStore.specialization.name]}
							buttonText="Изменить"
							icon={{ src: hospitalIcon }}
							onClick={redirect('/specializations')}
						/>
					)}
				</div>
				<div className="mb-2">
					{showClinics && (
						<SectionWithActionButton
							title="Клиники"
							subtitle={bookingStore.getClinicsNames()}
							placeholder="Все клиники"
							buttonText="Изменить"
							icon={{ src: clinicIcon, size: '25px' }}
							onClick={redirect('/clinics')}
						/>
					)}
				</div>
			</Fragment>
		);
	},
);
